import { isValidSha1Hash } from "../../../../utils";
import { Selection } from "../../../search/@types";
import { ExtractedFilesResultItem } from "../../@types";

export const getActiveItemTitle = (items: Array<Selection>, active: string) =>
  items.find(({ value }) => value === active)?.label;

export const filterValidHashes = (selected: Record<string, unknown>) =>
  Object.values(selected).filter(
    (item: ExtractedFilesResultItem) =>
      item.sample?.sha1 || isValidSha1Hash(item.sample?.sha1)
  );
